// extracted by mini-css-extract-plugin
export default {"link":"sCwlFvljiz0E2_FLqdcr","regular":"BYjGAru501jYr9P9IQtJ","external":"gCeEc7XcmICgKg5R09kQ","highlight":"WGkIT91Yu00QbocLnOeR","animate":"eJMEV7iG6aI0N1i4qWnR"};